/**
 * Share links (/s/:id) waiting for the street map, in arrival order: each settles to the
 * resolved link view, or null when there is nothing to show (offline, unknown link). Eager
 * and tiny: the manifest's mapDue reads it.
 */
import type { LinkViewDto } from '../../services/dto.js';

export const waiting: Promise<LinkViewDto | null>[] = [];
